import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is a digital marketplace, and how is it different from a traditional online
                                    store?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>A digital marketplace is an online platform that allows multiple sellers to offer
                                        their products or services to a large pool of buyers. Digital marketplaces
                                        differ from traditional online stores in that they provide a platform for
                                        multiple sellers to reach a broad audience rather than just one company selling
                                        its own products. Digital marketplaces can be a valuable way for businesses to
                                        expand their reach and increase their sales, as well as for consumers to find a
                                        wide variety of products and services in one place.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are some common features of digital marketplace development projects?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Some standard features of digital marketplace development projects include a
                                        user-friendly interface, search and filtering functionality, product and seller
                                        ratings and reviews, and secure payment processing. Other features may include
                                        support for multiple languages and currencies, integration with shipping and
                                        logistics systems, and analytics and reporting capabilities.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    Can TekRevol help me develop a digital marketplace for my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Yes, TekRevol has a team of experienced software developers with expertise in
                                        developing digital marketplaces. We have a track record of success in creating
                                        custom digital marketplace solutions for businesses of all sizes. Our team is
                                        proficient in emerging programming languages and frameworks, and we have the
                                        skills and knowledge to help you create a digital marketplace that meets your
                                        specific needs and goals. Whether you're looking to expand your reach, increase
                                        your sales, or offer your customers a wider variety of products and services, we
                                        can help you create a digital marketplace solution that works for you.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    What is the digital marketplace?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Digital marketplaces are online platforms that connect both sellers and buyers, facilitating the pairing of individuals in search of a service or product with those who offer such products or services.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;